import { onServiceAnswer } from '../../api/client';
import type { Listing } from '../../domain/listings';
import { DraftOutbox } from './draftOutbox';
import { DraftSyncEngine } from './draftSyncEngine';
import type { DraftSyncTransport } from './DraftSyncTransport';

/** A page's drafts and the engine syncing them, for one signed-in account. */
export type DraftSync = {
  outbox: DraftOutbox;
  engine: DraftSyncEngine;
  /**
   * Hear about each draft the service now holds as the device has it, just
   * before it leaves the outbox, so a list can show the server copy in its
   * place without a gap (R5).
   */
  onSynced(listener: (listing: Listing) => void): () => void;
  /** Sign-out or account deletion: stop syncing and drop every draft (FR-009d, R10). */
  discard(): void;
};

export function createDraftSync(accountId: string, transport: DraftSyncTransport): DraftSync {
  const listeners = new Set<(listing: Listing) => void>();
  const outbox = new DraftOutbox(accountId);
  const engine = new DraftSyncEngine({
    outbox,
    transport,
    hearsFromService: onServiceAnswer,
    onSynced: (listing) => listeners.forEach((listener) => listener(listing)),
  });
  return {
    outbox,
    engine,
    onSynced: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    discard: () => {
      engine.stop();
      outbox.purge();
    },
  };
}
